import axios from '../utils/axios';

export default function getUnicornData (adminId, params) {
    return axios.get(`/admin/${adminId}/get-unicorn-data`, { params });
}